export default __webpack_public_path__ + "static/media/pictogramDocument64.6e96f5bb.svg";